import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Loader";
import BuyPlanModal from "../../Components/Modals/BuyPlanModal";
import { getAllPackagesListReducer } from "../slice";

function Plans() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [modalName, setModalName] = useState("");
  const [packageId, setPackageId] = useState("");

  const handleShow = () => {
    setShow(!show);
  };
  const handlePage = (value) => {
    setPage(value);
  };

  const list = useSelector((store) => store.main.getAllPackagesList);

  const getList = useCallback(() => {
    setLoading(true);
    dispatch(
      getAllPackagesListReducer({
        page: page,
        limit: 12,
      })
    ).then((res) => {
      if (res?.payload?.code === 1) {
        setLoading(false);
      }
    });
  }, [dispatch, page]);

  useEffect(() => {
    getList();
  }, [getList]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
            <h3>Plans</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetueradipiscing elit. Aenean
              commodo ligula eget dolor. Aenean massa.
            </p>
          </div>
          {loading ? (
            <Loader colorChange="colorChange" />
          ) : list?.data?.length > 0 ? (
            list?.data?.map((item, i) => (
              <div
                className="col-sm-12 col-md-6 col-lg-4 mb-3 changePlanNameBox"
                key={i}
              >
                <div className="planBox">
                  <div className="PlanNameBox">
                    <h4>{item?.package?.packageName || "NA"}</h4>
                    <h2>
                      <i className="fa fa-inr"></i>{" "}
                      {item?.package?.price
                        ? parseFloat(item?.package?.price).toFixed(2)
                        : "NA"}
                    </h2>
                  </div>
                  <div className="planText px-3 text-capitalize ">
                    {item?.packageDetails?.map((cate, ii) => (
                      <>
                        <label key={ii} className="fw-bold">
                          {cate?._id?.categoryDetails?.categoryName}
                        </label>
                        <ul>
                          {cate?.subCategoryDetails?.map((sub, ind) => (
                            <li key={ind}>{sub?.subCat?.subCategoryName}</li>
                          ))}
                        </ul>
                      </>
                    ))}
                  </div>
                  <div className="text-center">
                    <span
                      className="buyBtn"
                      onClick={() => {
                        setPackageId(item?.package?._id);
                        setModalName("buy modal");
                        handleShow();
                      }}
                    >
                      Buy Now
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">No Plan Found</div>
          )}
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-end">
            <a
              href="https://api.whatsapp.com/send?phone=8005214320"
              target="_blank"
            >
              <img
                src="assets/images/Whatappicon.png"
                alt=""
                className="whatsappIcon"
              />
            </a>
          </div>
        </div>
      </div>

      {show && modalName === "buy modal" && packageId && (
        <BuyPlanModal
          show={show}
          handleShow={handleShow}
          packageId={packageId}
        />
      )}
    </>
  );
}

export default Plans;
